import React from "react";
import "../styles/ProductCard.css";

type ProductCardProps = {
  title: string;
  image: string;
  onClick: () => void;
  status: "available" | "coming soon";
};

const ProductCard: React.FC<ProductCardProps> = ({
  title,
  image,
  onClick,
  status,
}) => {
  return (
    <div
      className={`custom-product-card ${
        status === "coming soon" ? "disabled" : ""
      }`}
      onClick={status === "available" ? onClick : undefined}
    >
      <div className="product-image-wrapper">
        <img src={image} alt={title} className="product-image" />
        {status === "coming soon" && (
          <div className="status-label">Coming Soon</div>
        )}
      </div>
      <div className="product-title">{title}</div>
    </div>
  );
};

export default ProductCard;
